import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { getPatientList } from "~/store/patient/patientAction";
import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const PatientRecordsPageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "mobile" */ "~/components/mobile/pages/PatientRecords"
    ),
  loading: LoadableLoading
});
const PatientRecordsPageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "desktop" */ "~/components/mobile/pages/PatientRecords"
    ),
  loading: LoadableLoading
});

class DetectPatientRecords extends Component {
  componentDidMount() {
    this.props.getPatientList();
  }

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <PatientRecordsPageMobile />
        ) : (
          <PatientRecordsPageDesktop />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    }
  } = state;
  return {
    device: type
  };
};

const PatientRecordsHelmet = withTitle({
  component: DetectPatientRecords,
  title: `${hospitalName.value} | Hồ sơ bệnh nhân`
});

export default connect(mapStateToProps, { getPatientList })(
  PatientRecordsHelmet
);
